import { render, staticRenderFns } from "./memberRatio.vue?vue&type=template&id=647e39fa&"
import script from "./memberRatio.vue?vue&type=script&lang=js&"
export * from "./memberRatio.vue?vue&type=script&lang=js&"
import style0 from "./memberRatio.vue?vue&type=style&index=0&id=647e39fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports